import { render } from "./AuthorSelectDropdown.vue?vue&type=template&id=23cda8e1&scoped=true"
import script from "./AuthorSelectDropdown.vue?vue&type=script&lang=js"
export * from "./AuthorSelectDropdown.vue?vue&type=script&lang=js"

import "./AuthorSelectDropdown.vue?vue&type=style&index=0&id=23cda8e1&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cda8e1"]])

export default __exports__